"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _ = require("../..");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const headerTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'Header'];
const CollapseListItem = /*#__PURE__*/_react.default.forwardRef(({
  header,
  content,
  initialOpen,
  ...restProps
}, ref) => {
  const [open, setOpen] = (0, _react.useState)(initialOpen ? true : false);
  const contentRef = (0, _react.useRef)(null);
  const contentId = `content-${Math.random().toString(36).substring(2, 9)}`;
  const tag = (0, _react.useMemo)(() => getHtmlTag(header), [header]);
  const isHeadingOrHTMLHeading = headerTags.includes(tag || '');
  function getHtmlTag(node) {
    if (/*#__PURE__*/_react.default.isValidElement(node)) {
      const element = node;
      if (typeof element.type === 'function') {
        return element.type.name;
      } else if (typeof element.type === 'string') {
        return element.type;
      }
    }
    return null;
  }
  const toggleOpen = () => {
    setOpen(!open);
    if (!open && contentRef.current) {
      contentRef.current.focus(); // Optional focus management.
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    className: "item",
    ...restProps,
    role: restProps['role'] || 'listitem',
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CollapseButton, {
      onClick: toggleOpen,
      nostyle: true,
      "aria-expanded": open,
      "aria-controls": contentId,
      "aria-label": typeof header === 'string' ? `Toggle ${header}` : undefined,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "header",
        role: !isHeadingOrHTMLHeading ? 'heading' : undefined,
        children: [header, /*#__PURE__*/(0, _jsxRuntime.jsx)(_.IconChevronDown, {
          primary: true,
          flipVertical: open,
          size: '14px'
        })]
      })
    }), open && /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      role: "region",
      className: "content",
      id: contentId,
      "aria-hidden": !open,
      ref: contentRef,
      tabIndex: -1,
      "aria-live": "polite",
      children: content
    })]
  });
});
var _default = exports.default = CollapseListItem;